<template>
  <div class="overflow-visible rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Member Firms</h1>
          <p class="mt-2 text-sm text-gray-700">A list of all the Member Firms.</p>
        </div>
        <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none" v-if="isAdmin">
          <button @click="openAccountModal(null)" type="button" class="block rounded-md network-bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
            Add Account
          </button>
        </div>
        <div class="mt-4 sm:ml-1 sm:mt-0 sm:flex-none">
          <a href="/member-firm/invitations/create" class="block rounded-md network-bg-primary px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
            Invite Firm
          </a>
        </div>

        <div class="mt-4 sm:mt-0 ml-2 sm:flex-none">
          <select
              id="filter"
              name="filter"
              v-model="selectedFilter"
              @change="handleFilterChange"
              class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
            <option disabled selected value="">Filters</option>
            <option value="">---</option>
            <option value="invitation_accepted">Invitation accepted</option>
            <option value="invitation_pending">Invitation is pending</option>
          </select>
        </div>

      </div>
      <SearchComponent @setSearchText="setSearchText"/>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-visible sm:-mx-6 lg:-mx-8">

          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
              <tr>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">Account</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Owner</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">
                  <ClipboardDocumentCheckIcon class="m-1 h-6 w-6" aria-hidden="true" />
                </th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">
                  <img :src="'/img/icon-focus-gloss.png'" class="flex-none min-w-6 w-6">
                </th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">
                  <img :src="'/img/icon-engagement-gloss.png'" class="flex-none min-w-6 w-6">
                </th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">
                  <img :src="'/img/icon-consumerduty-gloss.png'" class="flex-none min-w-6 w-6">
                </th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">
                  <img :src="'/img/icon-promise-gloss.png'" class="flex-none min-w-6 w-6">
                </th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">
                  <img :src="'/img/icon-systems-gloss.png'" class="flex-none min-w-6 w-6">
                </th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">
                  <img :src="'/img/icon-people-gloss.png'" class="flex-none min-w-6 w-6">
                </th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Created at</th>
                <th scope="col" class="px-3 py-1 text-right text-sm font-semibold text-gray-900"></th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
              <tr v-for="item in items" :key="item.id">
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <a :href="item.account_link" class="network-button-color hover:text-gray-900">
                    {{ item.account_name }}
                  </a>
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  {{ item.owner_user }}
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  {{ item.question_set }}
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <a :href="item.focus_link" class="network-button-color hover:text-gray-900">
                    {{ item.focus_score }}
                  </a>
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <a :href="item.engagement_link" class="network-button-color hover:text-gray-900">
                    {{ item.engagement_score }}
                  </a>
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <a :href="item.consumerduty_link" class="network-button-color hover:text-gray-900">
                    {{ item.consumerduty_score }}
                  </a>
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <a :href="item.promise_link" class="network-button-color hover:text-gray-900">
                    {{ item.promise_score }}
                  </a>
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <a :href="item.systems_link" class="network-button-color hover:text-gray-900">
                    {{ item.systems_score }}
                  </a>
                </td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                  <a :href="item.people_link" class="network-button-color hover:text-gray-900">
                    {{ item.people_score }}
                  </a>
                </td>

                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.created_at }}</td>

                <td class="py-1 pl-3 text-sm font-medium sm:pr-0">
                  <div class="flex items-center justify-end gap-x-0">
                    <button :id="'exportDocFileButton-' + item.id" :disabled="loadingIds[item.id]" @click="exportDocFile(item.id)" v-if="user?.owned_network?.key === 'sbg'" type="button" class="network-button-color hover:text-gray-900">
                      <svg v-if="loadingIds[item.id]" class="m-1 h-6 w-6 text-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><radialGradient id="a3" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)"><stop offset="0" stop-color="currentColor"></stop><stop offset=".3" stop-color="currentColor" stop-opacity=".9"></stop><stop offset=".6" stop-color="currentColor" stop-opacity=".6"></stop><stop offset=".8" stop-color="currentColor" stop-opacity=".3"></stop><stop offset="1" stop-color="currentColor" stop-opacity="0"></stop></radialGradient><circle transform-origin="center" fill="none" stroke="url(#a3)" stroke-width="24" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></circle><circle transform-origin="center" fill="none" opacity=".2" stroke="currentColor" stroke-width="24" stroke-linecap="round" cx="100" cy="100" r="70"></circle></svg>
                      <DocumentTextIcon v-else class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                    <a :href="item.tracker_link"  class="network-button-color hover:text-gray-900">
                      <i class="far fa-tasks m-1 fa-lg" aria-hidden="true"></i>
                    </a>
                    <button v-if="account.features.track_performance" @click="openAccountModal(item.id, AccountTrackPerformanceComponent())" type="button" class="network-button-color hover:text-gray-900">
                      <i class="fa fa-chart-line m-1 fa-lg" aria-hidden="true"></i>
                    </button>
                    <RouterLink :to="{ name: 'AccountShow', params: { id: item.id } }" class="network-button-color hover:text-gray-900">
                      <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </RouterLink>
                    <button @click="openAccountModal(item.id)" v-if="!isAuditor" type="button" class="network-button-color hover:text-gray-900">
                      <PencilSquareIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
<!--                    <button @click="destroy(item.id)" type="button" class="network-button-color hover:text-gray-900">-->
<!--                      <TrashIcon class="m-1 h-6 w-6" aria-hidden="true" />-->
<!--                    </button>-->

                    <Menu as="div" class="relative">
                      <div>
                        <MenuButton class="flex items-center rounded-full text-gray-500 hover:text-gray-600">
                          <span class="sr-only">Open options</span>
                          <EllipsisVerticalIcon class="h-6 w-6" aria-hidden="true" />
                        </MenuButton>
                      </div>

                      <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                        <MenuItems class="absolute right-0 z-40 mt-2 w-64 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <div class="py-1">
<!--                            <MenuItem v-slot="{ active }">-->
<!--                              <RouterLink :to="{ name: 'AccountShow', params: { id: item.id } }" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm']">-->
<!--                                Show-->
<!--                              </RouterLink>-->
<!--                            </MenuItem>-->

<!--                            <MenuItem v-slot="{ active }">-->
<!--                              <button @click="openAccountModal(item.id)" type="button" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm w-[100%] text-left']">-->
<!--                                Edit-->
<!--                              </button>-->
<!--                            </MenuItem>-->

                            <MenuItem v-slot="{ active }">
                              <div :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block inline-flex  px-4 py-2 text-sm w-[100%] text-left']">
                                <SwitchGroup as="div" class="flex items-center">
                                  <Switch @update:modelValue="changeViewQuestionSection('consumer_duty', item)" v-model="item.features_consumer_duty" :class="[item.features_consumer_duty ? 'bg-indigo-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2']">
                                    <span aria-hidden="true" :class="[item.features_consumer_duty ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
                                  </Switch>
                                  <SwitchLabel as="span" class="ml-3 text-sm">
                                    <span class="font-medium text-gray-900">Show Consumer Duty</span>
                                  </SwitchLabel>
                                </SwitchGroup>
                              </div>
                            </MenuItem>

                            <MenuItem v-slot="{ active }">
                              <button @click="exportAccount(1, item.id)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block inline-flex  px-4 py-2 text-sm w-[100%] text-left']">
                                <DocumentArrowDownIcon class="-ml-0.5 h-5 w-5 mr-2" aria-hidden="true" />
                                Member firm data all
                              </button>
                            </MenuItem>

                            <MenuItem v-slot="{ active }">
                              <button @click="exportAccount(2, item.id)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block inline-flex  px-4 py-2 text-sm w-[100%] text-left']">
                                <DocumentArrowDownIcon class="-ml-0.5 h-5 w-5 mr-2" aria-hidden="true" />
                                Member firm data latest
                              </button>
                            </MenuItem>

                            <MenuItem v-slot="{ active }" v-if="!isAuditor">
                              <button @click="destroy(item.id)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block inline-flex  px-4 py-2 text-sm w-[100%] text-left']">
                                <TrashIcon class="-ml-0.5 h-5 w-5 mr-2" aria-hidden="true" />
                                Delete
                              </button>
                            </MenuItem>

                            <template v-if="item.copy_invite_link">
                            <MenuItem v-slot="{ active }">
                              <button @click="copyToClipboard(item.copy_invite_link)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block inline-flex  px-4 py-2 text-sm w-[100%] text-left']">
                                <DocumentDuplicateIcon class="-ml-0.5 h-5 w-5 mr-2" aria-hidden="true" />
                                Copy Invite
                              </button>
                            </MenuItem>

                            <MenuItem v-slot="{ active }">
                              <button @click="resendInvitationEmail(item.network_invitation_id)" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block inline-flex  px-4 py-2 text-sm w-[100%] text-left']">
                                <ArrowUpOnSquareIcon class="-ml-0.5 h-5 w-5 mr-2" aria-hidden="true" />
                                Resend Invite
                              </button>
                            </MenuItem>
                            </template>

                          </div>
                        </MenuItems>
                      </transition>
                    </Menu>

                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "../TwPaginationComponent.vue";
import {EllipsisVerticalIcon, EyeIcon, PencilSquareIcon, TrashIcon} from "@heroicons/vue/20/solid";
import SearchComponent from "../SearchComponent.vue";
import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";
import AccountCreateEditFormComponent from "./AccountCreateEditFormComponent.vue";
import AccountTrackPerformanceComponent from "./AccountTrackPerformanceComponent.vue";
import {ClipboardDocumentCheckIcon, DocumentArrowDownIcon, DocumentDuplicateIcon, ArrowUpOnSquareIcon, DocumentTextIcon} from "@heroicons/vue/24/outline";
import {Menu, MenuButton, MenuItem, MenuItems, Switch, SwitchGroup, SwitchLabel} from "@headlessui/vue";

export default {
  name: "MemberFirmIndexComponent",
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null,
      searchText: null,
      selectedFilter: '',
      loadingIds: {},
    }
  },
  components: {
    SwitchLabel,
    Switch,
    SwitchGroup,
    Menu,
    MenuItem,
    MenuItems,
    MenuButton,
    PaginationComponent,
    EyeIcon,
    PencilSquareIcon,
    TrashIcon,
    SearchComponent,
    AccountCreateEditFormComponent,
    AccountTrackPerformanceComponent,
    ClipboardDocumentCheckIcon,
    EllipsisVerticalIcon,
    DocumentArrowDownIcon,
    DocumentDuplicateIcon,
    ArrowUpOnSquareIcon,
    DocumentTextIcon,
  },
  watch: {
    searchText: {
      handler(newValue, oldValue) {
        this.getItems();
      },
      deep: true
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuditor() {
      return this.$store.state.userIsAuditor;
    },
    isAdmin() {
      return this.$store.state.userIsAccountLevelAdmin;
    },
    account() {
      return this.$store.state.account;
    },
  },
  methods: {
    AccountTrackPerformanceComponent() {
      return AccountTrackPerformanceComponent
    },
    setSearchText(value) {
      this.searchText = value;
    },
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/index?page=${page}`, {params: {'search_text': this.searchText, 'selected_filter': this.selectedFilter}}).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    destroy(id) {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/accounts/destroy/${id}`).then((res) => {
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          this.getItems();
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        })
      }
    },
    openAccountModal(accountId, component = AccountCreateEditFormComponent) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: component,
            attrs: {
              accountId: accountId,
              onReloadIndex() {
                self.getItems();
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
    handleFilterChange() {
      // console.log('Selected Filter:', this.selectedFilter);
      this.getItems();
    },
    exportAccount(exportAccountOption, accountId) {
      axios.get(
          `/member-firm/options/export-account/${accountId}/${exportAccountOption}`,
          { responseType: 'blob' }
      ).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download',  accountId + '_export_account.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        this.$notify({ type: "success", title: "Successfully", text: 'Download in process' });
      }).catch((error) => {
            console.log('error', error);
          });
    },
    exportDocFile(accountId) {
      this.loadingIds[accountId] = true;
      axios.get(
          `/member-firm/assessment/export-doc-file/${accountId}`,
          {
            responseType: 'blob'
          }
      ).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;

        const disposition = response.headers['content-disposition'];
        let fileName = 'document.docx';
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const matches = disposition.match(/filename="?(.+)"?/);
          if (matches && matches[1]) {
            fileName = matches[1];
          }
        }

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);

        this.loadingIds[accountId] = false;
      }).catch((error) => {
        console.log('error', error);

        this.loadingIds[accountId] = false;
      });
    },
    changeViewQuestionSection(key, item) {
      let features_consumer_duty = item.features_consumer_duty;
      // console.log(key, item.id, features_consumer_duty);
      // axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrfToken;
      axios.put(
          `/member-firm/options/change-view-question-section/${item.id}`,
          {'key': key, 'value': !features_consumer_duty}
      ).then((res) => {
        item.features_consumer_duty = res.data.value;
        this.$notify({ type: "success", title: "Successfully", text: ' Changed view question section' });
      }).catch((error) => {
        console.log('error', error)
        item.features_consumer_duty = features_consumer_duty;
      })
    },
    copyToClipboard(link) {
      navigator.clipboard.writeText(link);
      this.$notify({ type: "success", title: "Successfully", text: 'Link copy to clipboard' });
    },
    resendInvitationEmail(networkInvitationId) {
      axios.post(
          `/member-firm/invitations/resend/${networkInvitationId}`,
      ).then((res) => {
            this.$notify({ type: "success", title: "Successfully", text: 'Resend Invitation Email' });
            this.$emit('cancel');
      }).catch((error) => {
            console.log('error', error);
            this.$notify({ title: "Unsuccessfully", text: 'Resend Invitation Email' });
      });
    }
  },
  created() {
    this.getItems();
  },
}
</script>